import { type Currency } from '@lingoda/graphql';
import { useFormatCurrencyCallback } from './useFormatCurrencyCallback';

export const useFormatCurrency = (amount: number, currency: Currency) => {
    const formatCurrency = useFormatCurrencyCallback();

    return formatCurrency(amount, currency);
};
